//防抖
export  function debounce(fn) {
    console.log(1)
    let t = null //只会执行一次
    debugger

    return function (){
        if(t){
            clearTimeout(t)
        }
        t = setTimeout(()=>{
            console.log(temp);  //可以获取
            // console.log(arguments[0]) //undefined
            fn.apply(this,arguments)
            //在这个回调函数里面的argument是这个回调函数的参数，因为没有参数所以undefined，可以通过外面的函数赋值来进行访问
            //也可以改变成箭头函数,箭头函数的this是指向定义函数的那一层的，所以访问到的arguments是上一层函数的arguments
        },1000)

    }
}
//节流
export function throttle(fn, delay = 200) {
    let timer = null
    console.log(fn);
    debugger
    return function () {
        if(timer) return
        timer = setTimeout(() => {
            debugger
          fn.apply(this,arguments)
          timer = null
        })
    }
 }
//下拉动画
export function animation(element, to) {
    const from = element.scrollTop;
    const duration = 300;
    const startTime = performance.now();
    function step(timestamp) {
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);
        element.scrollTop = from + (to - from) * progress;
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    }
    window.requestAnimationFrame(step);
}
  //判断文件类型
  export function judgeFileType(file) {
    if (file == null||file == ""){  
         alert("请选择要上传的图片!");  
         return false;  
    }  
    if (file.lastIndexOf('.')==-1){    //如果不存在"."    
        alert("路径不正确!");  
        return false;  
    }  
    var AllImgExt=".jpg|.jpeg|.gif|.bmp|.png|";  
    var extName = file.substring(file.lastIndexOf(".")).toLowerCase();//（把路径中的所有字母全部转换为小写）          
    if(AllImgExt.indexOf(extName+"|")==-1)          
    {  
        ErrMsg="该文件类型不允许上传。请上传 "+AllImgExt+" 类型的文件，当前文件类型为"+extName;  
        alert(ErrMsg);  
        return false;  
    }  
  }

  //文件类型
  export function fileType() {
    return {
      'application/msword': 'word',
      'application/pdf': 'pdf',
      'application/vnd.ms-powerpoint': 'ppt',
      'application/vnd.ms-excel': 'excel',
      'aplication/zip': 'zpi',
    }
  }

/**
 * 将日期转换为相对时间描述
 * @param {string|Date} date - 日期字符串或Date对象
 * @returns {string} 相对时间描述
 */
export const getRelativeTime = function (date) {
    // 将输入转换为Date对象
    const targetDate = new Date(date);
    const now = new Date();

    // 计算时间差（毫秒）
    const diffInMs = now - targetDate;
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInWeeks = Math.floor(diffInDays / 7);
    const diffInMonths = Math.floor(diffInDays / 30);
    const diffInYears = Math.floor(diffInDays / 365);

    // 根据时间差返回相应的描述
    if (diffInYears > 0) {
        return `${diffInYears}年前`;
    } else if (diffInMonths > 0) {
        return `${diffInMonths}个月前`;
    } else if (diffInWeeks > 0) {
        return `${diffInWeeks}周前`;
    } else if (diffInDays > 0) {
        return `${diffInDays}天前`;
    } else if (diffInHours > 0) {
        return `${diffInHours}小时前`;
    } else if (diffInMinutes > 0) {
        return `${diffInMinutes}分钟前`;
    } else {
        return '刚刚';
    }
}

/**
 * 时间戳转指定格式日期字符串
 * @param {number|string} timestamp - 时间戳（毫秒）
 * @param {string} format - 格式字符串，如："YYYY"、"YYYY-MM-DD"、"YYYY-MM-DD HH:mm:ss"
 * @returns {string} 格式化后的日期字符串
 */
export function timestampToDate(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
    // 确保timestamp是数字类型
    timestamp = Number(timestamp);

    if (isNaN(timestamp)) {
        throw new Error('时间戳必须是有效的数字');
    }

    const date = new Date(timestamp);

    // 日期各部分映射
    const map = {
        'YYYY': date.getFullYear(),
        'MM': String(date.getMonth() + 1).padStart(2, '0'),
        'DD': String(date.getDate()).padStart(2, '0'),
        'HH': String(date.getHours()).padStart(2, '0'),
        'mm': String(date.getMinutes()).padStart(2, '0'),
        'ss': String(date.getSeconds()).padStart(2, '0'),
        'M': date.getMonth() + 1, // 不补零的月份
        'D': date.getDate(), // 不补零的日期
    };

    // 替换格式字符串中的占位符
    return format.replace(/YYYY|MM|DD|HH|mm|ss|M|D/g, (matched) => {
        return map[matched] || matched;
    });
}